import { Request, Response } from "express"

import { getCategories } from "#services/categories"

export const routeGetCategories = async (_req: Request, res: Response) => {
	const list = await getCategories()

	res.json(list)
}
